import { cycleRate, rateLabel, useRate } from '@/lib/playbackRate';
import { Tooltip } from '@/components/ui/tooltip';

/** Кнопка скорости звука: по клику 1× → 1.5× → 2× → 1×. Общая для всех плееров. */
export default function RateButton({ className = '' }: { className?: string }) {
  const rate = useRate();
  return (
    <Tooltip content="Скорость проигрывания"><button
      type="button"
      onClick={(e) => { e.stopPropagation(); cycleRate(); }}
      className={`inline-flex h-6 min-w-9 items-center justify-center rounded border px-1.5 font-mono text-[11px] tabular-nums ${rate !== 1 ? 'border-primary text-primary' : 'text-muted-foreground'} ${className}`}
    >
      {rateLabel(rate)}
    </button></Tooltip>
  );
}
